import * as React from 'react';
import { UIText1, UIText2, ArticleHeading0 } from '@cian/ui-kit';
import * as DOMPurify from 'isomorphic-dompurify';

import * as styles from './styles.css';
import { HoveredLink } from '../HoveredLink';
import { Layout } from '../Layout';

export interface IBuilderProps {
  logoUrl: string;
  name: string;
  yearOfFoundation?: number | null;
  done: React.ReactNode;
  inProgress: React.ReactNode;
  description: string | null;
  url?: string | null;
  onBuilderLinkClick(): void;
}

export function Builder({
  logoUrl,
  name,
  yearOfFoundation,
  done,
  inProgress,
  description,
  url,
  onBuilderLinkClick,
}: IBuilderProps) {
  return (
    <Layout>
      <div className={styles['nav_container']} id="developer">
        <div className={styles['container']}>
          <div className={styles['builder']}>
            {logoUrl && <div className={styles['logo']} style={{ backgroundImage: `url(${logoUrl})` }} />}
            <div className={styles['title']}>
              <UIText1 color="gray60_100">Застройщик</UIText1>
              <div className={styles['name']}>
                <ArticleHeading0 as="h2">{name}</ArticleHeading0>
              </div>
            </div>
          </div>
          <div>
            <div className={styles['statistic']}>
              {yearOfFoundation && (
                <div>
                  <ArticleHeading0>{yearOfFoundation}</ArticleHeading0>
                  <div className={styles['statistic-item-text']}>
                    <UIText2 fontWeight="bold">
                      год
                      <br />
                      основания
                    </UIText2>
                  </div>
                </div>
              )}
              {done}
              {inProgress}
            </div>
            {description && (
              <div className={styles['description']}>
                <UIText1>
                  <div
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(description) }}
                  />
                </UIText1>
              </div>
            )}
            {url && (
              <HoveredLink url={url} childNode={UIText2} onClick={onBuilderLinkClick}>
                Узнать больше о застройщике
              </HoveredLink>
            )}
          </div>
        </div>
      </div>
    </Layout>
  );
}
